export const name = 'DbListController';
export default function DbListController($mdDialog, $scope, $log, presetsService, L10NFilter, errorDialogOpen) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.showProgressBar = false;
  vm.knownProgress = false;

  vm.cancel = cancel;
  vm.onDbSelectedFun = onDbSelectedFun;
  vm.removeDbFun = removeDbFun;


  function onDbSelectedFun (newDb){
     vm.onDbSelected(newDb);
     $mdDialog.cancel();
  }
  function removeDbFun (dbToRemove){
    vm.removeDb(dbToRemove);
    if(vm.dbList.length === 1){
      $mdDialog.cancel();
    }
  }
  function cancel(){
    $mdDialog.cancel();
  }
}
